import { IStyle } from '@fluentui/react';
import { ICorptaxTheme } from '../ICorptaxTheme';
import { INotificationBadgeStyles } from './INotificationBadgeStyles';

export class CorptaxThemeNotificationBadgeStyles implements INotificationBadgeStyles {
    private baseStyles;

    constructor(private theme: ICorptaxTheme) {
        this.baseStyles = {
            position: 'absolute',
            top: '5px',
            right: '5px',
            borderRadius: '16px',
            textAlign: 'center',
            fontSize: '10px',
            background: this.theme.palette.red,
            padding: '0.2em 0.5em',
        };
    }

    get show() {
        return { ...this.baseStyles, display: 'block' } as IStyle;
    }
    get hide() {
        return { ...this.baseStyles, display: 'none' } as IStyle;
    }
}
